/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ oldal', // '/ page',
  jump_to: 'UgrÃ¡s', // 'Goto',
  jump_to_confirm: 'megerÅsÃ­t', // 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'ElÅzÅ oldal', // 'Previous Page',
  next_page: 'KÃ¶vetkezÅ oldal', // 'Next Page',
  prev_5: 'ElÅzÅ 5 oldal', // 'Previous 5 Pages',
  next_5: 'KÃ¶vetkezÅ 5 oldal', // 'Next 5 Pages',
  prev_3: 'ElÅzÅ 3 oldal', // 'Previous 3 Pages',
  next_3: 'KÃ¶vetkezÅ 3 oldal' // 'Next 3 Pages',
};
